import IconButton from "@/read-ui/IconButton";
import { CloseOutline, DownloadProcessOutline } from "@webnovel/chereads-icons";
import Icon from "@/read-ui/Icon";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import QRCode from "easyqrcodejs";
import { AF_ADSET, getDownloadLink } from "@/utils/appManager";
import { useRouter } from "next/router";
import { isMobile } from "@/utils/device";
import AsImage from "@/pages/Featured/components/Footer/images/as.png";
import GpImage from "@/pages/Featured/components/Footer/images/gp.png";
import styles from "./styles.module.scss";
import { QDReportSender, toDomProps } from "../QDReport";

function generateOption(text: string) {
  return {
    text: text,
    width: 164,
    height: 164,
    colorDark: "#000000",
    colorLight: "#ffffff",
    logo: "https://prewww.yueimg.com/chereads/_next/static/media/chereads_logo.8ec61d9c.png", // todo: change
    logoBackgroundColor: "#000",
    logoHeight: 40,
    logoWidth: 40,
    crossOrigin: "anonymous",
  };
}
const cardReport = {
  uiname: "mallchanneldl",
};
const asChannelReport = {
  uiname: "channeldl",
  dl: "1",
  dt: "appstore",
};
const gpChannelReport = {
  uiname: "channeldl",
  dl: "1",
  dt: "googleplay",
};
const codeChannelReport = {
  uiname: "channeldl",
  dl: "1",
  dt: "code",
};

const FloatDownloadButton = () => {
  const [isShowCard, setIsShowCard] = useState<boolean>(false);
  const [isShowButton, setIsShowButton] = useState<boolean>(false);
  const router = useRouter();
  const qrRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const downloadLink = getDownloadLink({
      router,
      afQuery: { af_adset: AF_ADSET.float_qrcode },
    });
    if (qrRef.current) {
      qrRef.current.innerHTML = ""; // 清空容器，否则会反复生成
      new QRCode(qrRef.current, generateOption(downloadLink));
    }
  }, [router]);
  useEffect(() => {
    setIsShowButton(isMobile());
  }, []);

  const handleShowCard = () => {
    setIsShowCard(true);
    QDReportSender({ ...cardReport, etype: "C" });
    QDReportSender({ ...asChannelReport, etype: "C" });
    QDReportSender({ ...gpChannelReport, etype: "C" });
    QDReportSender({ ...codeChannelReport, etype: "C" });
  };
  return (
    <>
      <div className={`br16 ${styles.card} pf ${isShowCard && "_show"}`}>
        <div className={`pa t0 l0 ${styles.icon}`} />
        <button
          className={"nu_reset cp pa t0 r0 mt8 mr8"}
          onClick={() => setIsShowCard(false)}
        >
          <Icon Svg={CloseOutline} className={"c_l fs12"} />
        </button>
        <div className={"t_body_m c_m"}>Download Chereads APP</div>
        <a
          href={"https://apps.apple.com/US/app/id1595743071?mt=8"}
          className={`br8 ${styles.downloadBtn} nu_reset mt12`}
          rel={"nofollow"}
          title={"Chereads App Store"}
          {...toDomProps(asChannelReport)}
        >
          <Image
            className={`fl ${styles.invert}`}
            width={134}
            alt={"Chereads App Store"}
            src={AsImage}
          />
        </a>
        <a
          href={
            "https://play.google.com/store/apps/details?id=com.chereads.reader"
          }
          className={`br8 ${styles.downloadBtn} nu_reset mt12`}
          rel={"nofollow"}
          title={"Chereads Google Play"}
          {...toDomProps(gpChannelReport)}
        >
          <Image
            className={"fl"}
            width={134}
            alt={"Google Play"}
            src={GpImage}
          />
        </a>
        <div className={`mt12 ${styles.QRCode}`} ref={qrRef} />
      </div>
      {isShowCard && (
        <div className={styles.mask} onClick={() => setIsShowCard(false)} />
      )}
      <IconButton
        className={`pf ${styles.btn} ${(isShowButton || isShowCard) && "dn"}`}
        circle
        icon={<Icon Svg={DownloadProcessOutline} size={16} />}
        size={"sm"}
        onClick={handleShowCard}
      />
    </>
  );
};
export default FloatDownloadButton;
